import { GET,} from "../../helper/xbi4RestFunctions";
export const getOrgProjectDetails = async (org_id: any, project_id: any) => {
  const path = `/orgs/${org_id}/projects/${project_id}`;
  return await GET(path)
    .then((result: any) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
